/* unplugin-vue-components disabled */import { render } from "./CTypeTab.vue?vue&type=template&id=0fe65dd4&scoped=true&ts=true"
import script from "./CTypeTab.vue?vue&type=script&lang=ts"
export * from "./CTypeTab.vue?vue&type=script&lang=ts"

import "./CTypeTab.vue?vue&type=style&index=0&id=0fe65dd4&scoped=true&lang=less"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe65dd4"]])

export default __exports__